import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { DELIVERY_PARTNER_IDS_MAP, DTDC_DELIVERY_STEPS } from './constants';
import { getUserPatientAddresses } from './helper';
import DeliveryDetailsForm from './components/dtdcForm/DeliveryDetailsForm';
import CourierDetailsForm from './components/dtdcForm/CourierDetailsForm';
import BackButton from './components/BackButton';

const initialDeliveryData = {
    "orderId": "",
    "billingAddressId": "",
    "serviceType": "",
    "recipientName": "",
    "recipientPhone": "",
    "packageDetails": {
        "units": 1,
        // "length": 5,
        // "breadth": 5,
        // "height": 5,
        // "weight": 0.5,
        "subTotal": 0,
        "isCod": false,
        "codAmount": 0,
        "containsLiquid": false,
    },
    "deliveryPartnerId": DELIVERY_PARTNER_IDS_MAP.DTDC,
}

const DTDCForm = ({ orderId, mapUserPatient, address, onClose, orderData, deliveryBoxImages = [] }) => {
    const [userPatientAddresses, setUserPatientAddresses] = useState([address]);
    const [deliveryData, setDeliveryData] = useState(initialDeliveryData);

    // Open-box photos live in the modal shell (DeliveryCreateModal) so all partner forms
    // share one field. Mirrored into `deliveryData` here because `deliveryData` IS the body
    // these forms POST -- no change to validation or the submit path itself.
    useEffect(() => {
        setDeliveryData((prevState) => ({ ...prevState, deliveryBoxImages }));
    }, [deliveryBoxImages]);
    const [currentStep, setCurrentStep] = useState(DTDC_DELIVERY_STEPS.DELIVERY_DETAILS);

    useEffect(() => {
        (async () => {
            if (mapUserPatient) {
                const res = await getUserPatientAddresses(mapUserPatient.id);
                if (res.length > 0) {
                    setUserPatientAddresses(res);
                }
            }
        })()
    }, [mapUserPatient]);

    useEffect(() => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                orderId: orderId,
                billingAddressId: address.id,
                packageDetails: {
                    ...prevState.packageDetails,
                    subTotal: orderData.total,
                }
            }
        });
    }, [])

    return (
        <div className='flex flex-col gap-[0.9rem]' >
            <div className='flex flex-col gap-[0.9rem]' >
                {
                    currentStep === DTDC_DELIVERY_STEPS.DELIVERY_DETAILS && <DeliveryDetailsForm deliveryData={deliveryData} setDeliveryData={setDeliveryData} userPatientAddresses={userPatientAddresses} mapUserPatient={mapUserPatient} onContinue={() => setCurrentStep(DTDC_DELIVERY_STEPS.SELECT_COURIER)} orderData={orderData} />
                }
                {
                    currentStep === DTDC_DELIVERY_STEPS.SELECT_COURIER && <CourierDetailsForm backButton={() => <BackButton onClick={() => setCurrentStep(DTDC_DELIVERY_STEPS.DELIVERY_DETAILS)} />} deliveryData={deliveryData} setDeliveryData={setDeliveryData} userPatientAddresses={userPatientAddresses} onContinue={onClose} />
                }
            </div>
        </div >
    )
}


DTDCForm.propTypes = {
    deliveryBoxImages: PropTypes.arrayOf(PropTypes.string),
    orderId: PropTypes.number.isRequired,
    mapUserPatient: PropTypes.object.isRequired,
    address: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    orderData: PropTypes.object.isRequired,
};

export default DTDCForm